export const CHANGE_VARIABLE = 'change_variable';
